import { computed } from 'vue';
import { useRoute } from 'vue-router';

export type RouteName = 'room' | 'rate' | 'details' | 'payment';

export function useCurrentBookingStep() {
  const route = useRoute();

  const currentStep = computed<RouteName>(() => {
    const routeName: string = route.name as string;
    const nameComponents = routeName.split('-');
    const stepNameDecorated = nameComponents[nameComponents.length - 1];
    const stepNameParts = stepNameDecorated.split('_');
    return stepNameParts[0] as RouteName;
  });

  return { currentStep };
}
